import { slugifyName } from "../slug";

const slugCache = new Map<string, string>();

function cachedSlug(text: string): string {
  let slug = slugCache.get(text);
  if (slug === undefined) {
    if (slugCache.size > 10_000) slugCache.clear();
    slug = slugifyName(text);
    slugCache.set(text, slug);
  }
  return slug;
}

export function matchesSearchText(
  candidates: (string | undefined)[],
  query: string
): boolean {
  const lower = query.toLowerCase();
  // Slugs compare at segment boundaries, not as substrings: slugification
  // collapses queries like ".NET" into generic tokens ("net") that would
  // otherwise match unrelated names ("netsuite").
  const slug = cachedSlug(query);
  return candidates.some(
    (c) =>
      c != null &&
      (c.toLowerCase().includes(lower) ||
        (slug !== "" && `-${cachedSlug(c)}-`.includes(`-${slug}-`)))
  );
}
